import { buildQueryContext } from '@superset-ui/core';

export default function buildQuery(formData: any) {
  return buildQueryContext(formData, () => [
    {
      // минимальный “не пустой” запрос: SELECT 1 ... LIMIT 1
      metrics: [
        {
          expressionType: 'SQL',
          sqlExpression: 'COUNT(*)',
          label: '__dummy__',
        },
      ],
      columns: [],
      groupby: [],
      row_limit: 1,
    },
  ]);
}
